// extracted by mini-css-extract-plugin
module.exports =  {"fs-badge-menu-form-items":"BadgeMenu-module__fs-badge-menu-form-items___GjXM1"};